import React from 'react';
import { LegalLayout } from './LegalLayout';
import { THtml } from '../../components/Translate';

const LEGAL_NOTICE_HTML = `
<h2>1. Identificación del Responsable</h2>
<p>Este sitio web es operado por <strong>PlanCity</strong>, con domicilio en Antofagasta, Chile. Para contactarnos puedes usar nuestro <a href="/contacto">formulario de contacto</a>.</p>

<h2>2. Objeto</h2>
<p>PlanCity opera una plataforma digital orientada a la difusión y descubrimiento de panoramas, eventos y actividades locales en Chile. Su uso se rige por los <a href="/terminos">Términos y Condiciones</a>, la <a href="/privacidad">Política de Privacidad</a> y la <a href="/cookies">Política de Cookies</a>.</p>

<h2>3. Propiedad Intelectual e Industrial</h2>
<p>El nombre comercial "PlanCity", su logotipo, isotipo, paleta de colores, código fuente, diseño, textos editoriales, manuales y demás elementos del sitio son propiedad de PlanCity o cuentan con las licencias necesarias, y se encuentran protegidos por la <strong>Ley N° 17.336 sobre Propiedad Intelectual</strong> y la <strong>Ley N° 19.039 sobre Propiedad Industrial</strong>.</p>
<p>Las fotografías, afiches y descripciones de eventos publicados por proveedores son responsabilidad de quien los carga. Si crees que un contenido vulnera tus derechos, contáctanos para gestionar su retiro.</p>

<h2>4. Enlaces a Sitios de Terceros</h2>
<p>El sitio puede contener enlaces a páginas externas (redes sociales, sitios de proveedores, OpenStreetMap, plataformas de pago, etc.). PlanCity no controla ni se responsabiliza por el contenido ni las políticas de privacidad de dichos sitios.</p>

<h2>5. Limitación de Responsabilidad</h2>
<p>Salvo dolo o culpa grave, PlanCity no responde por los daños y perjuicios que pudieran derivarse del uso o imposibilidad de uso del sitio. Lo anterior no afecta los derechos irrenunciables que la legislación chilena reconoce a los consumidores.</p>

<h2>6. Reclamos y SERNAC</h2>
<p>Si eres consumidor y tienes un reclamo, puedes contactarnos directamente. Asimismo, puedes acudir al <strong>Servicio Nacional del Consumidor (SERNAC)</strong> a través de <a href="https://www.sernac.cl" target="_blank" rel="noreferrer noopener">www.sernac.cl</a>.</p>

<h2>7. Legislación y Jurisdicción</h2>
<p>Este Aviso Legal se rige por la legislación de la República de Chile. Cualquier controversia será sometida a la jurisdicción de los Juzgados Civiles con competencia en el domicilio del consumidor.</p>
`;

export const LegalNotice = () => {
  return (
    <LegalLayout
      title="Aviso Legal"
      lastUpdated="18 de mayo de 2026"
      path="/aviso-legal"
      description="Aviso Legal de PlanCity: identificación del responsable, propiedad intelectual y condiciones generales de uso."
    >
      <THtml html={LEGAL_NOTICE_HTML} />
    </LegalLayout>
  );
};

export default LegalNotice;
